import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

/* Marco común de las cuatro páginas legales: mismo aire, misma tipografía,
   mismos colores de la paleta.  Las páginas sólo aportan el texto. */

export function LegalPage({ title, subtitle, updated, children }) {
  return (
    <div className="bg-papel text-tinta min-h-[70vh]">
      <Helmet>
        <title>{`${title} – Blauer Wolf Verlag`}</title>
        {/* Indexables a propósito: están en el sitemap y el Impressum debe
            poder encontrarse. Sólo se les baja la prioridad. */}
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="mx-auto max-w-3xl px-5 sm:px-8 py-16 sm:py-20">
        <h1 className="font-serif text-3xl sm:text-4xl tracking-titulo leading-tight mb-4">
          {title}
        </h1>
        {subtitle && <p className="text-sombra mb-2">{subtitle}</p>}
        {updated && <p className="rotulo text-sombra mb-12">{updated}</p>}
        {!updated && <div className="mb-12" />}

        <div>{children}</div>
      </div>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section className="mb-9">
      <h2 className="font-serif text-xl sm:text-[1.4rem] leading-snug text-loboOscuro mb-3">
        {title}
      </h2>
      <div className="text-tinta/80 leading-relaxed space-y-3">{children}</div>
    </section>
  );
}

export function LegalList({ items }) {
  return (
    <ul className="space-y-2 pl-5">
      {items.map((it, i) => (
        <li key={i} className="list-disc marker:text-lobo">
          {it}
        </li>
      ))}
    </ul>
  );
}

export function LegalMail({ children = "office@bw-verlag.at" }) {
  return (
    <a
      className="text-loboOscuro underline underline-offset-4 hover:text-tinta break-all"
      href={`mailto:${children}`}
    >
      {children}
    </a>
  );
}

export function LegalRoute({ to, children }) {
  return (
    <Link
      className="text-loboOscuro underline underline-offset-4 hover:text-tinta"
      to={to}
    >
      {children}
    </Link>
  );
}

export function LegalLink({ href, children }) {
  return (
    <a
      className="text-loboOscuro underline underline-offset-4 hover:text-tinta break-words"
      href={href}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
}
